module.exports = __webpack_public_path__ + "img/name4.872a884c.png";